import {debounceTime, startWith, pairwise} from 'rxjs/operators';
import {Component, OnInit, OnChanges, Input} from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, Validators, UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TypesService, FormBuilderService} from '../../../services';
import {
  BasicIncomeModel,
  EmploymentDetailsModel,
  SelfEmployedAddbackModel,
  SingleEmploymentModel, SinglePreviousEmploymentModel
} from '../../../models/widgets/employment-details-model';
import * as uuid from 'uuid';
import * as _ from 'lodash';
import {noSameValues, partnershipValidator} from '../../../_global/validators/custom-validators.directive';
import Decimal from 'decimal.js';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {DataHandlerService} from '../../../services/data-handler.service';
import { BehaviorSubject } from 'rxjs';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgIf, NgFor, NgClass } from '@angular/common';
import {
  AbnSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/abn-search/abn-search.component';
import {
  MatInputCommifiedDirective
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/commified/mat-input-commified-directive';
import {
  FurtherAdvanceConfirmationComponent
} from '../further-advance-confirmation/further-advance-confirmation.component';

@Component({
    selector: 'app-employment-details',
    templateUrl: './employment-details.component.html',
    styles: [],
    standalone: true,
  imports: [NgIf, MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgFor, MatButtonModule, MatButtonModule,
    MatFormFieldModule, MatFormFieldModule, MatInputModule, MatInputModule, MatSelectModule, MatSelectModule,
    MatOptionModule, MatOptionModule, MatIconModule, MatTooltipModule, MatCheckboxModule, MatCheckboxModule,
    ValidationPartialComponent, NgClass, AbnSearchComponent, MatInputCommifiedDirective, FurtherAdvanceConfirmationComponent]
})

export class EmploymentDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public personList: UntypedFormArray;
  @Input() public faType: string;
  @Input() public isSMSF = false;
  @Input() public isInternalUser = false;
  @Input() public applicationType: string;
  @Input() public productCategory: any;
  @Input() public isFurtherAdvance = false;

  public employmentFormArray: any;

  public employmentTypesSlug = 'employment-basis-vx';
  public employmentCategoryVx = 'employment-category-vx';
  public employmentStatusTypesSlug = 'employment-status-types-vx';
  public incomeSourceTypeSlug = 'income-source-types';
  public frequencyTypesSlug = 'frequencies-vx';
  public companyTypesVxSlug = 'company-types-vx';
  public selfEmployedBusinessTypesSlug = 'self-employed-business-types';
  public anzsicCategoriesSlug = 'anzsic-categories';
  public anzsicCategories = [];
  public yesNoTypesSlug = 'yn'; // FIXME: update with slug based
  public employmentTypes = [];
  public employmentStatusTypes = [];
  public selfEmployedBusinessTypes = [];
  public debtServiceAddbacksTypes = [];
  public nasOtherIncomeTypes = [];
  public nasSalaryIncomeTypes = [];
  public companyTypes = [];
  public incomeSourceTypes = [];
  public salaryIncomeSourceTypes = [];
  public otherIncomeSourceTypes = [];
  public nonTaxableIncomeSourceTypes = [];
  public employmentCategoryVxTypes = [];
  public frequencyTypes = [];
  public yesNoTypes = [];
  public isDisableAnzsic = true;

  constructor(private typesService: TypesService,
              public formBuilder: UntypedFormBuilder,
              private formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.dataHandlerService.getApplicantForRemoval()
      .subscribe((index: any) => {
        if (index && index >= 0) {
          this.employmentFormArray.removeAt(index);
        }
      });

    Promise.all([
      this.populateEmploymentTypes(),
      this.populateAnzsicCategories(),
      this.populateEmploymentStatusTypes(),
      this.populateFrequencyTypes(),
      this.populateCategoryTypes(),
      this.populateIncomeSourceTypes(),
      this.populateCompanyTypes(),
      this.populateSelfEmployedTypes(),
      this.populateProbation(),
    ]).then(() => {
      // set the validation of the components at initialization
      if (this.employmentFormArray) {
        this.setupParentValidationAndCalcs();
      }
    });

    this.personList.valueChanges.pipe(
      debounceTime(350),
      startWith(''),
      pairwise(),
    ).subscribe(([old, newValue]) => {
      if (JSON.stringify(old) === JSON.stringify(newValue)) {
        return;
      }
      this.updateEmploymentDetails();
    });
  }

  ngOnChanges(changes) {
    if (this.formGroup) {
      !this.formGroup.get('employmentList') && this.formGroup.setControl('employmentList', this.formBuilder.array([]));
      this.employmentFormArray = this.formGroup.get('employmentList');
      this.employmentFormArray.setValidators(partnershipValidator());

      this.updateEmploymentDetails();
    }
  }

  setupParentValidationAndCalcs() {
    if (this.employmentFormArray.controls && this.employmentFormArray.controls.length > 0) {
      this.employmentFormArray.controls.forEach(fg => {
        this.formBuilderService.setValidationRules(new EmploymentDetailsModel(), fg);
        const setupEmploymentValidators = (arrayFg) => {
          this.formBuilderService.setValidationRules(new SingleEmploymentModel(), arrayFg);
          this.setupEmploymentFgBehaviors(arrayFg);
        };
        _.each(fg.get('currentEmployments').controls, setupEmploymentValidators);
        _.each(fg.get('previousEmployments').controls, setupEmploymentValidators);

        this.setupSelfEmployedValueChanges(fg.get('currentEmployments'));
        if (fg.value.currentEmployments.length === 0) {
          this.addEmployment(fg);
        }

        this.togglePrevEmployer(fg.get('currentEmployments'), fg.get('previousEmployments'));
      });
    }

    // set validation on self-employed partnerships
    this.employmentFormArray.setValidators(partnershipValidator());
    this.employmentFormArray.updateValueAndValidity();
  }


  /**
   * @param formGroup Formgroup for an employment
   */
  public setupEmploymentFgBehaviors(formGroup) {
    if (!formGroup.get('incomes')) {
      formGroup.addControl('incomes', new UntypedFormArray([]));
    }
    if (!formGroup.get('allowableAddBacks')) {
      formGroup.addControl('allowableAddBacks', new UntypedFormArray([]));
    }

    formGroup.get('allowableAddBacks').setValidators(noSameValues('addbackType', [{
      'name': 'other-company',
      maxCount: 2
    }]));

    const doParentChildLinks = (old, newValue) => {
      if (JSON.stringify(old) === JSON.stringify(newValue)) {
        return;
      }
      const link = formGroup.value.link;
      const toRemove = _.filter(old, i => newValue && !newValue.includes(i));
      const toAdd = _.filter(newValue, i => !old || (old && !old.includes(i)));

      // add a linked self-employment
      toAdd.forEach((partner: any) => {
        const partnerFg = this.employmentFormArray.controls[partner];
        this.addSelfEmployment(partnerFg, formGroup);
      });

      // Remove linked self-employments
      toRemove.forEach((partner: any) => {
        const partnerFg = this.employmentFormArray.controls[partner];
        if (partnerFg) {
          const currentEmps = partnerFg.get('currentEmployments') as UntypedFormArray;
          const idx = _.findIndex(currentEmps.value, e => e.link === link);
          if (idx !== -1) {
            currentEmps.removeAt(idx);
            if (currentEmps.length === 0) {
              this.addEmployment(partnerFg);
            }
          }
        }
      });
    };

    if (!formGroup.get('partnerships')) {
      formGroup.setControl('partnerships', new UntypedFormControl());
    }

    formGroup.get('partnerships').valueChanges.pipe(
      startWith(formGroup.get('partnerships').value),
      pairwise()
    ).subscribe(([old, newValue]) => {
      doParentChildLinks(old, newValue);
    });

    const setPercentageValidators = (value) => {
      if (value === 'partnership') {
        formGroup.get('percentage').setValidators(Validators.compose([Validators.required, Validators.max(99.99), Validators.min(0.01)]));
      } else if (value === 'sole-trader') {
        // sole trader gets 100% partnership
        if (!formGroup.get('percentage')) {
          formGroup.setControl('percentage', new UntypedFormControl());
        }

        formGroup.get('percentage').clearValidators();
        formGroup.get('percentage').patchValue(null, {emitEvent: false});
        formGroup.get('partnerships').patchValue([], {emitEvent: true});

        if (formGroup.get('link').value) {
          this.resetLinkedEmployment(formGroup.get('link').value);
        }
      }
      formGroup.get('percentage')?.updateValueAndValidity();
    };

    if (!formGroup.get('businessType')) {
      formGroup.setControl('businessType', new UntypedFormControl());
    }

    formGroup.get('businessType').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        setPercentageValidators(result);
      });
    setPercentageValidators(formGroup.value.businessType);

    if (!formGroup.get('previousYearIncome')) {
      formGroup.setControl('previousYearIncome', new UntypedFormControl());
    }

    formGroup.get('previousYearIncome').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        this.calculateSelfEmployedIncome(formGroup);
      });

    if (!formGroup.get('currentYearIncome')) {
      formGroup.setControl('currentYearIncome', new UntypedFormControl());
    }

    formGroup.get('currentYearIncome').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        this.calculateSelfEmployedIncome(formGroup);
      });

    formGroup.get('status').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        this.handleEmploymentStatusChange(formGroup, result);
        this.toggleSelfEmployedValidators(result, formGroup.value.basis, formGroup);
      });
    this.handleEmploymentStatusChange(formGroup, formGroup.value.status, false);

    formGroup.get('basis').valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        this.toggleSelfEmployedValidators(formGroup.value.status, result, formGroup);
      });
    this.toggleSelfEmployedValidators(formGroup.value.status, formGroup.value.basis, formGroup);
  }

  public toggleSelfEmployedValidators(status, basis, formGroup) {
    if (!this.isSMSF && status === 'self-employed' && basis === 'self-employed' && formGroup.value.currencyType === 'current') {
      formGroup.get('businessType').setValidators(Validators.required);
      formGroup.get('businessType').updateValueAndValidity();

      formGroup.get('currentYearIncome').setValidators(Validators.required);
      formGroup.get('currentYearIncome').updateValueAndValidity();

      formGroup.get('previousYearIncome').setValidators(Validators.required);
      formGroup.get('previousYearIncome').updateValueAndValidity();

      formGroup.get('requireIncomes').patchValue(false, {emitEvent: false});

      // remove all incomes
      const fa = formGroup.get('incomes');
      while (fa.controls.length) {
        fa.removeAt(0);
      }
      formGroup.updateValueAndValidity();

    } else {

      formGroup.get('businessType').patchValue(null, {emitEvent: false});
      formGroup.get('businessType').clearValidators();
      formGroup.get('businessType').updateValueAndValidity();

      formGroup.get('currentYearIncome').clearValidators();
      formGroup.get('currentYearIncome').updateValueAndValidity();

      formGroup.get('previousYearIncome').clearValidators();
      formGroup.get('previousYearIncome').updateValueAndValidity();

      // add an income to a self-employed PAYG
      if (status === 'self-employed' && basis !== 'self-employed') {
        formGroup.get('requireIncomes').patchValue(true, {emitEvent: false});
        if (formGroup.value.incomes.length === 0) {
          this.addIncome(formGroup.get('incomes'));
        }
      }
    }
  }

  public updateEmploymentDetails() {
    if (this.employmentFormArray && this.employmentFormArray.controls) {
      if (this.employmentFormArray.controls.length < this.personList.value.length) {
        while (this.employmentFormArray.controls.length < this.personList.value.length) {
          this.addEmploymentDetail();
        }
      } else if (this.employmentFormArray.controls.length > this.personList.value.length) {
        const diff = this.employmentFormArray.controls.length - this.personList.value.length;


        for (let i = 0; i < diff; i++) {
          const lastPersonIndex = this.employmentFormArray.length - 1;
          this.employmentFormArray.removeAt(lastPersonIndex);
          // remove all partnerships involving that borrower
          _.each(this.employmentFormArray.controls, empFg => {
            _.each(empFg.get('currentEmployments').controls, (singleEmployment, curEmploymentIdx) => {
              if (singleEmployment) {
                const v = singleEmployment.value;
                if (v.partnerships && v.partnerships.includes(lastPersonIndex)) {
                  if (v.parent) {
                    const newValue = _.filter(singleEmployment.get('partnerships').value, idx => idx !== lastPersonIndex);
                    singleEmployment.get('partnerships').patchValue(newValue, {emitEvent: false});
                  }
                }
              }

            });
          });
        }
      }

      this.disablePartnershipFields();
      this.checkSmsfValidations();
      this.updateAnzsicValidator();
    }
  }

  resetLinkedEmployment(link) {
    this.employmentFormArray.controls.forEach((borrowerEmployment: any, borrowerIndex: number) => {
      borrowerEmployment.get('currentEmployments').controls.forEach((employment: any, employmentIndex: number) => {
        if (link === employment.getRawValue().link && !employment.getRawValue().parent) {
          borrowerEmployment.get('currentEmployments').removeAt(employmentIndex);
          this.addEmployment(borrowerEmployment);
        }
      });
    });
  }

  disablePartnershipFields() {
    this.employmentFormArray.controls.forEach((borrowerEmployment: any, borrowerIndex: number) => {
      borrowerEmployment.get('currentEmployments').controls.forEach((employment: any, employmentIndex: number) => {
        if (!employment.value.parent && employment.value.link) {
          employment.get('businessType').disable({emitEvent: false});
          employment.get('partnerships').disable({emitEvent: false});
          employment.get('status').disable({emitEvent: false});
          employment.get('category').disable({emitEvent: false});
          employment.get('basis').disable({emitEvent: false});
        }
      });
    });
  }

  checkSmsfValidations() {
    this.employmentFormArray.controls.forEach((employmentControl: any) => {

      if (employmentControl) {
        employmentControl.controls.currentEmployments.controls.forEach((currentEmployment: any) => {
          if (this.isSMSF) {
            currentEmployment.get('incomes').controls.forEach((incomeUntypedFormGroup: any) => {
              incomeUntypedFormGroup.get('type').clearValidators();
              incomeUntypedFormGroup.get('frequency').clearValidators();
              incomeUntypedFormGroup.get('amount').clearValidators();
              incomeUntypedFormGroup.updateValueAndValidity();
            });
          } else if (!this.isSMSF && currentEmployment.get('incomes').controls && currentEmployment.get('incomes').controls.length > 0) {
            currentEmployment.get('incomes').controls.forEach((incomeUntypedFormGroup: any) => {
              incomeUntypedFormGroup.get('type').setValidators(Validators.compose([Validators.required]));
              incomeUntypedFormGroup.get('frequency').setValidators(Validators.compose([Validators.required]));
              incomeUntypedFormGroup.get('amount').setValidators(Validators.compose([Validators.required, Validators.min(0), Validators.pattern('^[0-9\.]*$')]));
              incomeUntypedFormGroup.updateValueAndValidity();
            });
          }

          this.togglePrevEmployer(employmentControl.get('currentEmployments'), employmentControl.get('previousEmployments'));
        });
      }
    });
  }

  /**
   * Anzsic category required only on 1st current employer, others wont be required since its hidden field
   */
  updateAnzsicValidator() {
    if (!this.applicationType) {
      return;
    }
    // If not an internal user skip the updating of anzsic validator
    // VX-69792 Business Rule : only show anzsic category for car loan, home loan and company that has first person borrower
    const enabledApplicationType = ['new-company', 'new-personal', 'new-bridging', 'old-personal'];

    this.isDisableAnzsic = !this.isInternalUser || (this.productCategory === 'home-loan' && !enabledApplicationType.includes(this.applicationType));

    const employmentList = this.formGroup.get('employmentList') as UntypedFormArray;
    employmentList.controls.forEach((employment, borrowerIndex) => {
      const currentEmployments = employment.get('currentEmployments') as UntypedFormArray;

      if (currentEmployments && currentEmployments.length > 0) {
        const anzsicCategory = currentEmployments.at(0).get('anzsicCategory');
        if (anzsicCategory) {
          if (!this.isDisableAnzsic) {
            const personDetails = this.personList.value[borrowerIndex];
            if (borrowerIndex === 0 && personDetails.borrowerGuarantor === 'borrower') {
              anzsicCategory.setValidators([Validators.required]);
            } else {
              anzsicCategory.clearValidators();
              anzsicCategory.setValue('');
            }
          } else {
            anzsicCategory.clearValidators();
            anzsicCategory.setValue('');
          }
          anzsicCategory.updateValueAndValidity();
        }
      }
    });
  }

  public addEmploymentDetail() {
    const arrayControl = <UntypedFormArray>this.employmentFormArray;
    const formGroup = this.formBuilder.group({
      currentEmployments: new UntypedFormArray([]),
      previousEmployments: new UntypedFormArray([]),
      otherIncomes: new UntypedFormArray([]),
      nonTaxableIncomes: new UntypedFormArray([]),
    });
    arrayControl.push(formGroup);
    this.addEmployment(formGroup);
  }

  public addEmployment(formGroup, borrowerIndex = null) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new SingleEmploymentModel());
    this.formBuilderService.setValidationRules(new SingleEmploymentModel(), fg);

    const link = uuid.v1();
    fg.get('link').patchValue(link, {emitEvent: false});

    if (this.isInternalUser && borrowerIndex === 0 && this.personList.value[borrowerIndex].borrowerGuarantor === 'borrower' && !this.isDisableAnzsic) {
      fg.get('anzsicCategory').setValidators(Validators.compose([Validators.required]));
      fg.get('anzsicCategory').updateValueAndValidity();
    }

    formGroup.get('currentEmployments').push(fg);
    this.setupEmploymentFgBehaviors(fg);
    this.addIncome(fg.get('incomes'));
  }

  public addSelfEmployment(formGroup, employmentUntypedFormGroup) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new SingleEmploymentModel());
    this.formBuilderService.setValidationRules(new SingleEmploymentModel(), fg);

    fg.addControl('incomes', new UntypedFormArray([]));
    fg.addControl('allowableAddBacks', new UntypedFormArray([])); // make sure addbacks are the same FA for child and parent

    fg.get('percentage').setValidators(Validators.compose([Validators.required, Validators.max(99.99), Validators.min(0.01)]));
    fg.get('employer').patchValue((employmentUntypedFormGroup.get('employer').value) ? employmentUntypedFormGroup.get('employer').value : '', {emitEvent: false});
    fg.get('link').patchValue(employmentUntypedFormGroup.get('link').value, {emitEvent: false});
    fg.get('parent').patchValue(false, {emitEvent: false});
    fg.get('status').patchValue(employmentUntypedFormGroup.get('status').value, {emitEvent: false});
    fg.get('category').patchValue(employmentUntypedFormGroup.get('category').value, {emitEvent: false});
    fg.get('abnAcnNumber').patchValue(employmentUntypedFormGroup.get('abnAcnNumber').value, {emitEvent: false});
    fg.get('businessType').patchValue(employmentUntypedFormGroup.get('businessType').value, {emitEvent: false});
    fg.get('previousYearIncome').patchValue(employmentUntypedFormGroup.get('previousYearIncome').value, {emitEvent: false});
    fg.get('previousYearTotalIncome').patchValue(employmentUntypedFormGroup.get('previousYearTotalIncome').value, {emitEvent: false});
    fg.get('currentYearIncome').patchValue(employmentUntypedFormGroup.get('currentYearIncome').value, {emitEvent: false});
    fg.get('currentYearTotalIncome').patchValue(employmentUntypedFormGroup.get('currentYearTotalIncome').value, {emitEvent: false});

    fg.get('businessType').disable({emitEvent: false});
    fg.get('partnerships').disable({emitEvent: false});
    fg.get('status').disable({emitEvent: false});
    fg.get('category').disable({emitEvent: false});
    fg.get('basis').disable({emitEvent: false});

    const patchPartners = () => {
      // get borrower index with this link
      const partners = _.reduce(this.employmentFormArray.value, (a, e, i) => {
        const match = e.currentEmployments.find(cur => cur.link === fg.value.link);
        if (match) {
          a.push(i);
        }
        return a;
      }, []);
      fg.get('partnerships').patchValue(partners, {emitEvent: false});
    };
    patchPartners();

    employmentUntypedFormGroup.valueChanges
      .pipe(debounceTime(300))
      .subscribe((result: any) => {
        fg.get('employer').patchValue((result.employer) ? result.employer : '', {emitEvent: false});
        fg.get('basis').patchValue(result.basis, {emitEvent: false});
        fg.get('category').patchValue(result.category, {emitEvent: false});
        fg.get('abnAcnNumber').patchValue(result.abnAcnNumber, {emitEvent: false});
        fg.get('previousYearIncome').patchValue(result.previousYearIncome, {emitEvent: false});
        fg.get('currentYearIncome').patchValue(result.currentYearIncome, {emitEvent: false});

        patchPartners();

        this.calculateSelfEmployedIncome(fg);
      });

    formGroup.get('currentEmployments').insert(0, fg);
  }

  public removeEmployment(index, formArray) {
    const arrayControl = <UntypedFormArray>formArray;
    arrayControl.removeAt(index);
    this.togglePrevEmployer(formArray.parent.get('currentEmployments'), formArray.parent.get('previousEmployments'));
    this.formGroup.updateValueAndValidity();
  }

  public addPreviousEmployment(formArray) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new SinglePreviousEmploymentModel());
    this.formBuilderService.setValidationRules(new SinglePreviousEmploymentModel(), fg);

    if (this.isInternalUser) {
      fg.get('anzsicCategory').setValidators(Validators.compose([]));
      fg.get('anzsicCategory').updateValueAndValidity();
    }

    formArray.push(fg);
  }

  public removePreviousEmploymentAfterIndex(index, formArray) {
    const arrayControl = <UntypedFormArray>formArray;
    arrayControl.removeAt(index);
    while (arrayControl.at(index)) {
      arrayControl.removeAt(index);
    }
  }

  public addIncome(formArray) {
    if (!this.isSMSF) {
      const fg = this.formBuilderService.convertObjectToFormGroup(new BasicIncomeModel());
      this.formBuilderService.setValidationRules(new BasicIncomeModel(), fg);
      formArray.push(fg);
    }
  }

  public removeIncome(formArray, index) {
    const arrayControl = formArray as UntypedFormArray;
    arrayControl.removeAt(index);
  }

  selectAbnRecord(record, employmentFg: UntypedFormGroup) {
    employmentFg.get('employer').patchValue((_.get(record, 'match-name._text', null)) ? _.get(record, 'match-name._text', null) : '', {emitEvent: false});
  }

  /**
   * Addbacks are only added on the parent FG
   * @param formGroup the parent FG
   */
  addAddback(formGroup?) {
    const fg = this.formBuilderService.convertObjectToFormGroup(new SelfEmployedAddbackModel());
    this.formBuilderService.setValidationRules(new SelfEmployedAddbackModel(), fg);

    fg.get('addbackLink').patchValue(uuid.v1(), {emitEvent: false});

    fg.get('addbackCurrentYearIncome').valueChanges.pipe(
      debounceTime(300))
      .subscribe((result: any) => {
        this.calculateSelfEmployedIncome(formGroup);
      });

    fg.get('addbackPreviousYearIncome').valueChanges.pipe(
      debounceTime(300))
      .subscribe((result: any) => {
        this.calculateSelfEmployedIncome(formGroup);
      });

    formGroup.get('allowableAddBacks').push(fg);
  }

  removeAddback(formGroup, index) {
    const arrayControl = formGroup.get('allowableAddBacks') as UntypedFormArray;
    arrayControl.removeAt(index);

    this.calculateSelfEmployedIncome(formGroup);
  }


  setupSelfEmployedValueChanges(formArray) {
    if (formArray) {
      formArray.controls.forEach((formGroup: any) => {
        const link = formGroup.get('link').value;

        // setup calculation fields for the primary owner of the self employment
        if (formGroup.get('parent').value) {
          formGroup.get('previousYearIncome').valueChanges
            .pipe(debounceTime(300))
            .subscribe((result: any) => {
              this.calculateSelfEmployedIncome(formGroup);
            });

          formGroup.get('currentYearIncome').valueChanges
            .pipe(debounceTime(300))
            .subscribe((result: any) => {
              this.calculateSelfEmployedIncome(formGroup);
            });

          formGroup.get('allowableAddBacks').controls.forEach((addBackFg: any) => {
            addBackFg.get('addbackCurrentYearIncome').valueChanges
              .pipe(debounceTime(300))
              .subscribe((result: any) => {
                this.calculateSelfEmployedIncome(formGroup);
              });

            addBackFg.get('addbackPreviousYearIncome').valueChanges
              .pipe(debounceTime(300))
              .subscribe((result: any) => {
                this.calculateSelfEmployedIncome(formGroup);
              });
          });
        } else {
          if (link &&
            formGroup.get('status').value === 'self-employed' &&
            formGroup.get('basis').value === 'self-employed') {
            this.employmentFormArray.value.forEach((brwUntypedFormGroup: any, index: number) => {
              const foundParentIndex = brwUntypedFormGroup.currentEmployments.findIndex(x => x.link === link && x.parent);

              if (foundParentIndex >= 0) {
                this.mirrorParentEmploymentValues(formGroup, this.employmentFormArray.controls[index].get('currentEmployments').controls[foundParentIndex]);
              }
            });
          }
        }
      });
    }
  }

  mirrorParentEmploymentValues(childUntypedFormGroup, parentUntypedFormGroup) {
    parentUntypedFormGroup.get('employer').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('employer').patchValue((result) ? result : '', {emitEvent: false});
      });

    parentUntypedFormGroup.get('category').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('category').patchValue(result, {emitEvent: false});
      });

    parentUntypedFormGroup.get('abnAcnNumber').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('abnAcnNumber').patchValue(result, {emitEvent: false});
      });

    parentUntypedFormGroup.get('currentYearIncome').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('currentYearIncome').patchValue(result, {emitEvent: false});
      });

    parentUntypedFormGroup.get('currentYearTotalIncome').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('currentYearTotalIncome').patchValue(result, {emitEvent: false});
      });

    parentUntypedFormGroup.get('previousYearIncome').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('previousYearIncome').patchValue(result, {emitEvent: false});
      });

    parentUntypedFormGroup.get('previousYearTotalIncome').valueChanges
      .subscribe((result) => {
        childUntypedFormGroup.get('previousYearTotalIncome').patchValue(result, {emitEvent: false});
      });

  }

  calculateSelfEmployedIncome(formGroup) {
    let currentYearTotal = 0;
    let previousYearTotal = 0;

    try {
      currentYearTotal = new Decimal(currentYearTotal).add(formGroup.value.currentYearIncome || 0).toNumber();
      previousYearTotal = new Decimal(previousYearTotal).add(formGroup.value.previousYearIncome || 0).toNumber();

      if (formGroup.value.allowableAddBacks && formGroup.value.allowableAddBacks.length > 0) {
        formGroup.value.allowableAddBacks.forEach((addBack: any, index: number) => {
          currentYearTotal = new Decimal(currentYearTotal || 0).add(addBack.addbackCurrentYearIncome || 0).toNumber();
          previousYearTotal = new Decimal(previousYearTotal || 0).add(addBack.addbackPreviousYearIncome || 0).toNumber();

          if (formGroup.value.allowableAddBacks.length === (index + 1)) {
            formGroup.get('currentYearTotalIncome').patchValue(currentYearTotal, {emitEvent: false});
            formGroup.get('previousYearTotalIncome').patchValue(previousYearTotal, {emitEvent: false});
          }
        });
      } else {
        if (formGroup.get('currentYearTotalIncome') && formGroup.get('previousYearTotalIncome')) {
          formGroup.get('currentYearTotalIncome').patchValue(currentYearTotal, {emitEvent: false});
          formGroup.get('previousYearTotalIncome').patchValue(previousYearTotal, {emitEvent: false});
        }
      }
    } catch (e) {
      console.log('Error trying to calculate SE income', e);
    }
  }

  toggleProbation(yearValue, probationFC) {
    if (Number(yearValue || 0) >= 1 && probationFC.value) {
      probationFC.patchValue(false, {emitEvent: false});
    }
  }

  async togglePrevEmployer(currentEmploymentUntypedFormArray, previousEmploymentUntypedFormArray) {
    const minEmploymentDuration = 24; // months
    let totalEmployedMonths = 0;

    const tenuresAreMissing = _.some(currentEmploymentUntypedFormArray.value, (e) => {
      return (e.lengthYears === '' || e.lengthYears === null || e.lengthYears === undefined)
        && (e.lengthMonths === '' || e.lengthMonths === null || e.lengthMonths === undefined);
    });

    // calculate the current employment length
    currentEmploymentUntypedFormArray.value.forEach((employment: any, index: number) => {
      totalEmployedMonths = totalEmployedMonths + ((employment.lengthYears || 0) * 12) + (employment.lengthMonths || 0);
    });

    if ((totalEmployedMonths >= minEmploymentDuration || tenuresAreMissing)
      && previousEmploymentUntypedFormArray.value && previousEmploymentUntypedFormArray.value.length > 0) {
      // remove the previous employment records
      this.removePreviousEmploymentAfterIndex(0, previousEmploymentUntypedFormArray);
    }

    // calculate the previous employment length
    if (previousEmploymentUntypedFormArray.value && previousEmploymentUntypedFormArray.value.length > 0) {
      let stopIndex = 0;
      previousEmploymentUntypedFormArray.value.forEach((employment: any, index: number) => {
        if (totalEmployedMonths >= minEmploymentDuration && !stopIndex) {
          stopIndex = index;
        }
        totalEmployedMonths = totalEmployedMonths + ((employment.lengthYears || 0) * 12) + (employment.lengthMonths || 0);
        this.checkEmployerValidation(employment.category, previousEmploymentUntypedFormArray.at(index));
        this.handleEmploymentStatusChange(previousEmploymentUntypedFormArray.at(index), employment.status);
      });
      if (stopIndex) {
        this.removePreviousEmploymentAfterIndex(stopIndex, previousEmploymentUntypedFormArray);
      }
    }

    // add previous employment record
    if (!tenuresAreMissing && totalEmployedMonths < minEmploymentDuration) {
      const emptyPreviousJob = previousEmploymentUntypedFormArray.value.find(e =>
        (e.lengthYears === '' || e.lengthYears === null || e.lengthYears === undefined)
        || (e.lengthMonths === '' || e.lengthMonths === null || e.lengthMonths === undefined)
      );

      if (!emptyPreviousJob) {
        this.addPreviousEmployment(previousEmploymentUntypedFormArray);
      }
    }

    if (previousEmploymentUntypedFormArray.controls && previousEmploymentUntypedFormArray.controls.length > 0) {
      previousEmploymentUntypedFormArray.controls.forEach((formGroup: any) => {
        if (formGroup.get('incomes') && formGroup.get('incomes').controls.length > 0) {
          formGroup.removeControl('incomes');
        }
      });
    }
  }

  public checkEmployerValidation(value, formGroup) {
    if (value === 'student' || value === 'pensioner') {
      formGroup.get('employer').patchValue('');
      formGroup.get('employer').disable();
      formGroup.get('employer').clearValidators();
      formGroup.get('employer').updateValueAndValidity();
    } else {
      if (formGroup.get('status').value === 'unemployed') {
        formGroup.get('employer').patchValue('');
        formGroup.get('employer').disable();
        formGroup.get('employer').clearValidators();
        formGroup.get('employer').updateValueAndValidity();
      } else {
        formGroup.get('employer').enable();
        formGroup.get('employer').setValidators([Validators.required]);
        formGroup.get('employer').updateValueAndValidity();
      }
    }
  }

  public populateAnzsicCategories() {
    return this.typesService.getTypesList(this.anzsicCategoriesSlug)
      .then((results: any) => {
        this.anzsicCategories = results;
      });
  }

  public populateEmploymentTypes() {
    return this.typesService.getTypesList(this.employmentTypesSlug)
      .then(results => {
        results.filter(type => {
          if (type.ext.Active === true) {
            this.employmentTypes.push(type);
          }
        });
      });
  }

  public populateEmploymentStatusTypes() {
    return this.typesService.getTypesList(this.employmentStatusTypesSlug)
      .then(results => {
        this.employmentStatusTypes = results;
      });
  }

  public populateFrequencyTypes() {
    return this.typesService.getTypesList(this.frequencyTypesSlug)
      .then(results => {
        results.filter(type => {
          const excludes = ['maturity', 'daily'];
          if (type.ext.Active === true && !excludes.includes(type.id)) {
            this.frequencyTypes.push(type);
          }
        });
      });
  }

  public populateCategoryTypes() {
    return this.typesService.getTypesList(this.employmentCategoryVx)
      .then(results => {
        this.employmentCategoryVxTypes = results;
      });
  }

  public populateProbation() {
    return this.typesService.getTypesList(this.yesNoTypesSlug)
      .then(results => {
        this.yesNoTypes = results;
      });
  }

  public populateIncomeSourceTypes() {
    return this.typesService.getTypesList(this.incomeSourceTypeSlug)
      .then((results: any) => {
        const incomeSourceTypes = results.filter((x: any) => !x.ext.immutable);
        const otherIncomeTypes = ['salary', 'other', 'nonspousal', 'interst-addback'];
        const nonTaxableIncomeTypes = ['nontax'];
        const salaryIncomeTypes = ['salary'];
        this.salaryIncomeSourceTypes = incomeSourceTypes.filter(x => x.ext.incomeCategory && salaryIncomeTypes.includes(x.ext.incomeCategory) && !x.ext.companyIncome);
        this.otherIncomeSourceTypes = incomeSourceTypes.filter(x => x.ext.incomeCategory && otherIncomeTypes.includes(x.ext.incomeCategory) && !x.ext.companyIncome && !x.ext.isSMSF);
        this.nonTaxableIncomeSourceTypes = incomeSourceTypes.filter(x => x.ext.incomeCategory && nonTaxableIncomeTypes.includes(x.ext.incomeCategory) && !x.ext.companyIncome && !x.ext.isSMSF);
        this.debtServiceAddbacksTypes = incomeSourceTypes.filter(x => x.ext.incomeCategory === 'addback');

        this.nasOtherIncomeTypes = _.clone(this.otherIncomeSourceTypes);
        this.nasOtherIncomeTypes.splice(this.otherIncomeSourceTypes.findIndex(x => x.id === 'non-applicant-spouse'), 1);
        this.salaryIncomeSourceTypes = _.sortBy(this.salaryIncomeSourceTypes, ({id}) => id === 'salary' ? 0 : 1);
      });
  }

  public handleEmploymentStatusChange(formGroup: UntypedFormGroup, value, patchBasis = true) {
    const employmentStatus = _.find(this.employmentStatusTypes, ['id', value]);

    const fieldMappings = {
      'occupation': ['occupation'],
      'categoryType': [],
      'lengthMonths': [],
      'employer': ['employer'],
      'abn': [],
    };

    if (employmentStatus) {
      const {
        validBasis = [],
        defaultBasis,
        requiredFields,
        requireIncomes = false
      } = employmentStatus.ext;

      const currentBasisIsValid = validBasis.includes(formGroup.value.basis);
      // reset the basis
      formGroup.setControl('validBasis', new UntypedFormControl([]));
      formGroup.setControl('requireIncomes', new UntypedFormControl(requireIncomes));
      if (validBasis && validBasis.length > 0) {
        formGroup.get('validBasis').patchValue(validBasis, {emitEvent: false});
      } else {
        formGroup.get('validBasis').patchValue(_.map(this.employmentTypes, 'id'), {emitEvent: false});
      }

      if (patchBasis) {
        if (defaultBasis && !currentBasisIsValid) {
          formGroup.get('basis').patchValue(defaultBasis, {emitEvent: false});
        } else if (!currentBasisIsValid) {
          formGroup.get('basis').patchValue(null, {emitEvent: false});
        }
      }

      if (requiredFields && requiredFields.length > 0) {

        // get all controls related to validation rules
        const allControls = _.reduce(Object.keys(fieldMappings), (f, n) => f.concat(fieldMappings[n]), []);
        const fieldsToRequire = _.reduce(_.filter(Object.keys(fieldMappings), (k) => requiredFields.includes(k)), (f, n) => f.concat(fieldMappings[n]), []);

        _.each(allControls, controlName => {
          const control = formGroup.get(controlName);
          if (control) {
            if (fieldsToRequire.includes(controlName)) {
              control.enable();
              control.setValidators(Validators.required);
              control.updateValueAndValidity();
            } else {
              control.patchValue('', {emitEvent: false});
              control.disable();
              control.clearValidators();
              control.updateValueAndValidity();
            }
          }
        });
      }

      if (!this.isSMSF) {
        const incomeFa = (formGroup.get('incomes') as UntypedFormArray);
        if (requireIncomes && incomeFa && incomeFa.controls.length === 0) {
          this.addIncome(formGroup.get('incomes'));
        } else if (!requireIncomes && !validBasis.includes('self-employed-payg')) {
          while (incomeFa.controls.length) {
            incomeFa.removeAt(0);
          }
        }
      }
    }

    if (value !== 'self-employed') {
      this.removeSelfEmployedPartnerships(formGroup);

      if (formGroup.get('link')?.value && formGroup.get('parent')?.value) {
        this.resetLinkedEmployment(formGroup.get('link').value);
      }
    }

    if (value === 'retired') {
      formGroup.get('employer').disable();
      formGroup.get('employer').patchValue('', {emitEvent: false});
      const incomeFa = (formGroup.get('incomes') as UntypedFormArray);
      if (incomeFa && incomeFa.controls.length > 0) {
        while (incomeFa.controls.length) {
          incomeFa.removeAt(0);
        }
      }
    }

    if (formGroup.get('category').value === 'student' || formGroup.get('category').value === 'pensioner') {
      formGroup.get('employer').clearValidators();
      formGroup.get('employer').updateValueAndValidity();
    }
  }

  removeSelfEmployedPartnerships(formGroup: UntypedFormGroup) {
    if (formGroup.get('partnerships')) {
      formGroup.get('partnerships').patchValue([], {emitEvent: false});
      const percentageFC = formGroup.get('percentage');
      if (percentageFC) {
        percentageFC.patchValue(null, {emitEvent: false});
        percentageFC.clearValidators();
        percentageFC.updateValueAndValidity();
      }
    }
  }

  public async populateCompanyTypes() {
    this.companyTypes = await this.typesService.getTypesList(this.companyTypesVxSlug);
  }

  public async populateSelfEmployedTypes() {
    this.selfEmployedBusinessTypes = await this.typesService.getTypesList(this.selfEmployedBusinessTypesSlug);
  }
}
